import type {UnicodePropertyMap} from "./parser/parse.js";
import {slug} from "./parser/parse.js";

/**
All Unicode properties supported by Oniguruma 6.9.10 (Unicode 16.0.0).
Copied from <github.com/kkos/oniguruma/blob/master/doc/UNICODE_PROPERTIES>
*/
const OnigUnicodePropertyMap: UnicodePropertyMap = /* @__PURE__ */ new Map(
`ASCII_Hex_Digit
Adlam
Ahom
Alphabetic
Anatolian_Hieroglyphs
Any
Arabic
Armenian
Assigned
Avestan
Balinese
Bamum
Bassa_Vah
Batak
Bengali
Bhaiksuki
Bidi_Control
Bopomofo
Brahmi
Braille
Buginese
Buhid
C
Canadian_Aboriginal
Carian
Case_Ignorable
Cased
Caucasian_Albanian
Cc
Cf
Chakma
Cham
Changes_When_Casefolded
Changes_When_Casemapped
Changes_When_Lowercased
Changes_When_Titlecased
Changes_When_Uppercased
Cherokee
Chorasmian
Cn
Co
Common
Coptic
Cs
Cuneiform
Cypriot
Cypro_Minoan
Cyrillic
Dash
Default_Ignorable_Code_Point
Deprecated
Deseret
Devanagari
Diacritic
Dives_Akuru
Dogra
Duployan
Egyptian_Hieroglyphs
Elbasan
Elymaic
Emoji
Emoji_Component
Emoji_Modifier
Emoji_Modifier_Base
Emoji_Presentation
Ethiopic
Extended_Pictographic
Extender
Garay
Georgian
Glagolitic
Gothic
Grantha
Grapheme_Base
Grapheme_Extend
Grapheme_Link
Greek
Gujarati
Gunjala_Gondi
Gurmukhi
Gurung_Khema
Han
Hangul
Hanifi_Rohingya
Hanunoo
Hatran
Hebrew
Hex_Digit
Hiragana
Hyphen
IDS_Binary_Operator
IDS_Trinary_Operator
IDS_Unary_Operator
ID_Compat_Math_Continue
ID_Compat_Math_Start
ID_Continue
ID_Start
Ideographic
Imperial_Aramaic
InCB
Inherited
Inscriptional_Pahlavi
Inscriptional_Parthian
Javanese
Join_Control
Kaithi
Kannada
Katakana
Kawi
Kayah_Li
Kharoshthi
Khitan_Small_Script
Khmer
Khojki
Khudawadi
Kirat_Rai
L
LC
Lao
Latin
Lepcha
Limbu
Linear_A
Linear_B
Lisu
Ll
Lm
Lo
Logical_Order_Exception
Lowercase
Lt
Lu
Lycian
Lydian
M
Mahajani
Makasar
Malayalam
Mandaic
Manichaean
Marchen
Masaram_Gondi
Math
Mc
Me
Medefaidrin
Meetei_Mayek
Mende_Kikakui
Meroitic_Cursive
Meroitic_Hieroglyphs
Miao
Mn
Modi
Modifier_Combining_Mark
Mongolian
Mro
Multani
Myanmar
N
Nabataean
Nag_Mundari
Nandinagari
Nd
New_Tai_Lue
Newa
Nko
Nl
No
Noncharacter_Code_Point
Nushu
Nyiakeng_Puachue_Hmong
Ogham
Ol_Chiki
Ol_Onal
Old_Hungarian
Old_Italic
Old_North_Arabian
Old_Permic
Old_Persian
Old_Sogdian
Old_South_Arabian
Old_Turkic
Old_Uyghur
Oriya
Osage
Osmanya
Other_Alphabetic
Other_Default_Ignorable_Code_Point
Other_Grapheme_Extend
Other_ID_Continue
Other_ID_Start
Other_Lowercase
Other_Math
Other_Uppercase
P
Pahawh_Hmong
Palmyrene
Pattern_Syntax
Pattern_White_Space
Pau_Cin_Hau
Pc
Pd
Pe
Pf
Phags_Pa
Phoenician
Pi
Po
Prepended_Concatenation_Mark
Ps
Psalter_Pahlavi
Quotation_Mark
Radical
Regional_Indicator
Rejang
Runic
S
Samaritan
Saurashtra
Sc
Sentence_Terminal
Sharada
Shavian
Siddham
SignWriting
Sinhala
Sk
Sm
So
Soft_Dotted
Sogdian
Sora_Sompeng
Soyombo
Sundanese
Sunuwar
Syloti_Nagri
Syriac
Tagalog
Tagbanwa
Tai_Le
Tai_Tham
Tai_Viet
Takri
Tamil
Tangsa
Tangut
Telugu
Terminal_Punctuation
Thaana
Thai
Tibetan
Tifinagh
Tirhuta
Todhri
Toto
Tulu_Tigalari
Ugaritic
Unified_Ideograph
Unknown
Uppercase
Vai
Variation_Selector
Vithkuqi
Wancho
Warang_Citi
White_Space
XID_Continue
XID_Start
Yezidi
Yi
Z
Zanabazar_Square
Zl
Zp
Zs
Adlm
Aghb
AHex
Arab
Armi
Armn
Avst
Bali
Bamu
Bass
Batk
Beng
Bhks
Bidi_C
Bopo
Brah
Brai
Bugi
Buhd
Cakm
Cans
Cari
Cased_Letter
Cher
Chrs
CI
Close_Punctuation
Combining_Mark
Connector_Punctuation
Control
Copt
Cpmn
Cprt
Currency_Symbol
CWCF
CWCM
CWL
CWT
CWU
Cyrl
Dash_Punctuation
Decimal_Number
Dep
Deva
DI
Dia
Diak
Dogr
Dsrt
Dupl
EBase
EComp
Egyp
Elba
Elym
EMod
Enclosing_Mark
EPres
Ethi
Ext
ExtPict
Final_Punctuation
Format
Gara
Geor
Glag
Gong
Gonm
Goth
Gran
Gr_Base
Grek
Gr_Ext
Gr_Link
Gujr
Gukh
Guru
Hang
Hani
Hano
Hatr
Hebr
Hex
Hira
Hluw
Hmng
Hmnp
Hung
IDC
Ideo
IDS
IDSB
IDST
IDSU
Initial_Punctuation
Ital
Java
Join_C
Kali
Kana
Khar
Khmr
Khoj
Kits
Knda
Krai
Kthi
Lana
Laoo
Latn
Lepc
Letter
Letter_Number
Limb
Lina
Linb
Line_Separator
LOE
Lowercase_Letter
Lyci
Lydi
Mahj
Maka
Mand
Mani
Marc
Mark
Math_Symbol
MCM
Medf
Mend
Merc
Mero
Mlym
Modifier_Letter
Modifier_Symbol
Mong
Mroo
Mtei
Mult
Mymr
Nagm
Nand
Narb
Nbat
NChar
Nkoo
Nonspacing_Mark
Nshu
Number
OAlpha
ODI
Ogam
OGr_Ext
OIDC
OIDS
Olck
OLower
OMath
Onao
Open_Punctuation
Orkh
Orya
Osge
Osma
Other
Other_Letter
Other_Number
Other_Punctuation
Other_Symbol
Ougr
OUpper
Palm
Paragraph_Separator
Pat_Syn
Pat_WS
Pauc
PCM
Perm
Phag
Phli
Phlp
Phnx
Plrd
Private_Use
Prti
punct
Punctuation
Qaac
Qaai
QMark
RI
Rjng
Rohg
Runr
Samr
Sarb
Saur
SD
Separator
Sgnw
Shaw
Shrd
Sidd
Sind
Sinh
Sogd
Sogo
Sora
Soyo
Space_Separator
Spacing_Mark
STerm
Sund
Sunu
Surrogate
Sylo
Symbol
Syrc
Tagb
Takr
Tale
Talu
Taml
Tang
Tavt
Telu
Term
Tfng
Tglg
Thaa
Tibt
Tirh
Titlecase_Letter
Tnsa
Todr
Tutg
Ugar
UIdeo
Unassigned
Uppercase_Letter
Vaii
Vith
VS
Wara
Wcho
WSpace
XIDC
XIDS
Xpeo
Xsux
Yezi
Yiii
Zanb
Zinh
Zyyy
Zzzz
In_Basic_Latin
In_Latin_1_Supplement
In_Latin_Extended_A
In_Latin_Extended_B
In_IPA_Extensions
In_Spacing_Modifier_Letters
In_Combining_Diacritical_Marks
In_Greek_and_Coptic
In_Cyrillic
In_Cyrillic_Supplement
In_Armenian
In_Hebrew
In_Arabic
In_Syriac
In_Arabic_Supplement
In_Thaana
In_NKo
In_Samaritan
In_Mandaic
In_Syriac_Supplement
In_Arabic_Extended_B
In_Arabic_Extended_A
In_Devanagari
In_Bengali
In_Gurmukhi
In_Gujarati
In_Oriya
In_Tamil
In_Telugu
In_Kannada
In_Malayalam
In_Sinhala
In_Thai
In_Lao
In_Tibetan
In_Myanmar
In_Georgian
In_Hangul_Jamo
In_Ethiopic
In_Ethiopic_Supplement
In_Cherokee
In_Unified_Canadian_Aboriginal_Syllabics
In_Ogham
In_Runic
In_Tagalog
In_Hanunoo
In_Buhid
In_Tagbanwa
In_Khmer
In_Mongolian
In_Unified_Canadian_Aboriginal_Syllabics_Extended
In_Limbu
In_Tai_Le
In_New_Tai_Lue
In_Khmer_Symbols
In_Buginese
In_Tai_Tham
In_Combining_Diacritical_Marks_Extended
In_Balinese
In_Sundanese
In_Batak
In_Lepcha
In_Ol_Chiki
In_Cyrillic_Extended_C
In_Georgian_Extended
In_Sundanese_Supplement
In_Vedic_Extensions
In_Phonetic_Extensions
In_Phonetic_Extensions_Supplement
In_Combining_Diacritical_Marks_Supplement
In_Latin_Extended_Additional
In_Greek_Extended
In_General_Punctuation
In_Superscripts_and_Subscripts
In_Currency_Symbols
In_Combining_Diacritical_Marks_for_Symbols
In_Letterlike_Symbols
In_Number_Forms
In_Arrows
In_Mathematical_Operators
In_Miscellaneous_Technical
In_Control_Pictures
In_Optical_Character_Recognition
In_Enclosed_Alphanumerics
In_Box_Drawing
In_Block_Elements
In_Geometric_Shapes
In_Miscellaneous_Symbols
In_Dingbats
In_Miscellaneous_Mathematical_Symbols_A
In_Supplemental_Arrows_A
In_Braille_Patterns
In_Supplemental_Arrows_B
In_Miscellaneous_Mathematical_Symbols_B
In_Supplemental_Mathematical_Operators
In_Miscellaneous_Symbols_and_Arrows
In_Glagolitic
In_Latin_Extended_C
In_Coptic
In_Georgian_Supplement
In_Tifinagh
In_Ethiopic_Extended
In_Cyrillic_Extended_A
In_Supplemental_Punctuation
In_CJK_Radicals_Supplement
In_Kangxi_Radicals
In_Ideographic_Description_Characters
In_CJK_Symbols_and_Punctuation
In_Hiragana
In_Katakana
In_Bopomofo
In_Hangul_Compatibility_Jamo
In_Kanbun
In_Bopomofo_Extended
In_CJK_Strokes
In_Katakana_Phonetic_Extensions
In_Enclosed_CJK_Letters_and_Months
In_CJK_Compatibility
In_CJK_Unified_Ideographs_Extension_A
In_Yijing_Hexagram_Symbols
In_CJK_Unified_Ideographs
In_Yi_Syllables
In_Yi_Radicals
In_Lisu
In_Vai
In_Cyrillic_Extended_B
In_Bamum
In_Modifier_Tone_Letters
In_Latin_Extended_D
In_Syloti_Nagri
In_Common_Indic_Number_Forms
In_Phags_pa
In_Saurashtra
In_Devanagari_Extended
In_Kayah_Li
In_Rejang
In_Hangul_Jamo_Extended_A
In_Javanese
In_Myanmar_Extended_B
In_Cham
In_Myanmar_Extended_A
In_Tai_Viet
In_Meetei_Mayek_Extensions
In_Ethiopic_Extended_A
In_Latin_Extended_E
In_Cherokee_Supplement
In_Meetei_Mayek
In_Hangul_Syllables
In_Hangul_Jamo_Extended_B
In_High_Surrogates
In_High_Private_Use_Surrogates
In_Low_Surrogates
In_Private_Use_Area
In_CJK_Compatibility_Ideographs
In_Alphabetic_Presentation_Forms
In_Arabic_Presentation_Forms_A
In_Variation_Selectors
In_Vertical_Forms
In_Combining_Half_Marks
In_CJK_Compatibility_Forms
In_Small_Form_Variants
In_Arabic_Presentation_Forms_B
In_Halfwidth_and_Fullwidth_Forms
In_Specials
In_Linear_B_Syllabary
In_Linear_B_Ideograms
In_Aegean_Numbers
In_Ancient_Greek_Numbers
In_Ancient_Symbols
In_Phaistos_Disc
In_Lycian
In_Carian
In_Coptic_Epact_Numbers
In_Old_Italic
In_Gothic
In_Old_Permic
In_Ugaritic
In_Old_Persian
In_Deseret
In_Shavian
In_Osmanya
In_Osage
In_Elbasan
In_Caucasian_Albanian
In_Vithkuqi
In_Todhri
In_Linear_A
In_Latin_Extended_F
In_Cypriot_Syllabary
In_Imperial_Aramaic
In_Palmyrene
In_Nabataean
In_Hatran
In_Phoenician
In_Lydian
In_Meroitic_Hieroglyphs
In_Meroitic_Cursive
In_Kharoshthi
In_Old_South_Arabian
In_Old_North_Arabian
In_Manichaean
In_Avestan
In_Inscriptional_Parthian
In_Inscriptional_Pahlavi
In_Psalter_Pahlavi
In_Old_Turkic
In_Old_Hungarian
In_Hanifi_Rohingya
In_Garay
In_Rumi_Numeral_Symbols
In_Yezidi
In_Arabic_Extended_C
In_Old_Sogdian
In_Sogdian
In_Old_Uyghur
In_Chorasmian
In_Elymaic
In_Brahmi
In_Kaithi
In_Sora_Sompeng
In_Chakma
In_Mahajani
In_Sharada
In_Sinhala_Archaic_Numbers
In_Khojki
In_Multani
In_Khudawadi
In_Grantha
In_Tulu_Tigalari
In_Newa
In_Tirhuta
In_Siddham
In_Modi
In_Mongolian_Supplement
In_Takri
In_Myanmar_Extended_C
In_Ahom
In_Dogra
In_Warang_Citi
In_Dives_Akuru
In_Nandinagari
In_Zanabazar_Square
In_Soyombo
In_Unified_Canadian_Aboriginal_Syllabics_Extended_A
In_Pau_Cin_Hau
In_Devanagari_Extended_A
In_Sunuwar
In_Bhaiksuki
In_Marchen
In_Masaram_Gondi
In_Gunjala_Gondi
In_Makasar
In_Kawi
In_Lisu_Supplement
In_Tamil_Supplement
In_Cuneiform
In_Cuneiform_Numbers_and_Punctuation
In_Early_Dynastic_Cuneiform
In_Cypro_Minoan
In_Egyptian_Hieroglyphs
In_Egyptian_Hieroglyph_Format_Controls
In_Egyptian_Hieroglyphs_Extended_A
In_Anatolian_Hieroglyphs
In_Gurung_Khema
In_Bamum_Supplement
In_Mro
In_Tangsa
In_Bassa_Vah
In_Pahawh_Hmong
In_Kirat_Rai
In_Medefaidrin
In_Miao
In_Ideographic_Symbols_and_Punctuation
In_Tangut
In_Tangut_Components
In_Khitan_Small_Script
In_Tangut_Supplement
In_Kana_Extended_B
In_Kana_Supplement
In_Kana_Extended_A
In_Small_Kana_Extension
In_Nushu
In_Duployan
In_Shorthand_Format_Controls
In_Symbols_for_Legacy_Computing_Supplement
In_Znamenny_Musical_Notation
In_Byzantine_Musical_Symbols
In_Musical_Symbols
In_Ancient_Greek_Musical_Notation
In_Kaktovik_Numerals
In_Mayan_Numerals
In_Tai_Xuan_Jing_Symbols
In_Counting_Rod_Numerals
In_Mathematical_Alphanumeric_Symbols
In_Sutton_SignWriting
In_Latin_Extended_G
In_Glagolitic_Supplement
In_Cyrillic_Extended_D
In_Nyiakeng_Puachue_Hmong
In_Toto
In_Wancho
In_Nag_Mundari
In_Ol_Onal
In_Ethiopic_Extended_B
In_Mende_Kikakui
In_Adlam
In_Indic_Siyaq_Numbers
In_Ottoman_Siyaq_Numbers
In_Arabic_Mathematical_Alphabetic_Symbols
In_Mahjong_Tiles
In_Domino_Tiles
In_Playing_Cards
In_Enclosed_Alphanumeric_Supplement
In_Enclosed_Ideographic_Supplement
In_Miscellaneous_Symbols_and_Pictographs
In_Emoticons
In_Ornamental_Dingbats
In_Transport_and_Map_Symbols
In_Alchemical_Symbols
In_Geometric_Shapes_Extended
In_Supplemental_Arrows_C
In_Supplemental_Symbols_and_Pictographs
In_Chess_Symbols
In_Symbols_and_Pictographs_Extended_A
In_Symbols_for_Legacy_Computing
In_CJK_Unified_Ideographs_Extension_B
In_CJK_Unified_Ideographs_Extension_C
In_CJK_Unified_Ideographs_Extension_D
In_CJK_Unified_Ideographs_Extension_E
In_CJK_Unified_Ideographs_Extension_F
In_CJK_Unified_Ideographs_Extension_I
In_CJK_Compatibility_Ideographs_Supplement
In_CJK_Unified_Ideographs_Extension_G
In_CJK_Unified_Ideographs_Extension_H
In_Tags
In_Variation_Selectors_Supplement
In_Supplementary_Private_Use_Area_A
In_Supplementary_Private_Use_Area_B
In_No_Block`.
  split(/\s/).
  map(p => [slug(p), p])
);

export {
  OnigUnicodePropertyMap,
};
